// 新协议
function kkmhhybrid_register_task_listener(opt) {
  hybrid({
    hybridParam: {
      schema: "kkmhhybrid",
      tagname: "register_task_listener",
    },
    on:true,
    callback: function (res) {
      opt.callback && opt.callback(res);
    }
  });
}

// 旧协议
function kkmh_registerTaskListener(opt) {
  window.returnTaskListener = function (res) {
    var params = {
      code: 200,
      data: JSON.parse(res),
      message: "ok"
    }
    opt.callback(params);
  }
  window.kkmh && window.kkmh.registerTaskListener(JSON.stringify({
    callBack: 'returnTaskListener'
  }));
}


/**
 * 注册App分发任务的监听 (游戏分发)<br>
 * kkmh.registerTaskListener，wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=43387273}<br>
 * kkmhhybrid://register_task_listener，wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=286458113}<br>
 * @param {Object} opt 参数对象
 * @param {Function} opt.callback 回调函数，由客户端在任务或进度发生变化时触发，一次触发只返回一个任务的状态
 * @param {Number} criticalAppVersion 新旧协议兼容的判断版本（默认值在hybrid/index.js里配置），客户端版本小于该值使用旧协议，其余使用新协议
 */
function register_task_listener(opt, criticalAppVersion) {
  var allow = window.kkBaseInfo.allowToKkmhhybrid(criticalAppVersion,582000);
  if (allow) {
    // 调用新协议
    kkmhhybrid_register_task_listener(opt);
  } else {
    // 调用旧协议
    kkmh_registerTaskListener(opt);
  }
}

export default register_task_listener;


// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/register_task_listener/index.js